/**
 * A compact array of bits backed by a Uint8Array. Used by the Bloom filter and
 * handy anywhere we need to pack booleans densely and count set bits quickly.
 */
export class BitArray {
  readonly size: number;
  readonly bytes: Uint8Array;

  constructor(size: number) {
    if (size <= 0) throw new RangeError("BitArray size must be positive");
    this.size = size;
    this.bytes = new Uint8Array((size + 7) >> 3);
  }

  get(i: number): boolean {
    return (this.bytes[i >> 3] & (1 << (i & 7))) !== 0;
  }

  set(i: number): void {
    this.bytes[i >> 3] |= 1 << (i & 7);
  }

  clear(i: number): void {
    this.bytes[i >> 3] &= ~(1 << (i & 7));
  }

  /** Number of bits currently set to 1. */
  popcount(): number {
    let total = 0;
    for (let b = 0; b < this.bytes.length; b++) total += POPCOUNT_TABLE[this.bytes[b]];
    return total;
  }
}

const POPCOUNT_TABLE = (() => {
  const t = new Uint8Array(256);
  for (let i = 0; i < 256; i++) t[i] = (i & 1) + t[i >> 1];
  return t;
})();
